import { executeRequest, JFSRequest } from '@jfs/network'
import { isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  const data = isSuccessResponse(response)
  return {
    ...data,
    status: data?.status ? 'true' : 'false',
  }
}

const fetchUploadedExcelFileDetailWithId = (tokens: any, id: string) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.fetchUploadedExcelFileDetailWithId),
    method: 'GET',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { fetchUploadedExcelFileDetailWithId }
